// Red-Green-Blue "A" orbit mark (official logo)
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_premium-home-tech-3/artifacts/toxelaay_AVISLogo.png";

export function AMark({ className = "h-7 w-7" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Integrated Solutions AV"
      className={`${className} object-contain`}
      aria-hidden="true"
    />
  );
}

export function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <AMark className="h-8 w-8 shrink-0" />
      {!compact && (
        <span className="leading-none">
          <span className="block font-sans text-[13px] font-500 uppercase tracking-[0.28em] text-white">
            Integrated Solutions
          </span>
          <span className="block font-mono text-[10px] uppercase tracking-[0.5em] text-isav-green/80">
            A V &nbsp;/&nbsp; Technology
          </span>
        </span>
      )}
    </span>
  );
}
